import React from "react";

function NoFilters() {
  return (
    <div className="text-4xl font-normal text-left p-12 leading-[3rem]">
      With Subscribe & Save you can get 20% off Brio filters & free automatic
      shipping, but your product does not require filters.{" "}
      <span className="text-brio-600 font-bold">Instead, enjoy 20% sitewide.</span>{" "}
      Complete sign up & receive an email with your discount code!
    </div>
  );
}

export default NoFilters;
